/**
 * @typedef {import('vue').default} Vue
 */
import * as Sentry from '@sentry/vue';

/**
 * Handle the name of the assets
 */
import {
  version as appVersion,
  name as appName,
} from '../../package.json';

/**
 * Initializes Sentry for prod env.
 @param {Vue} app - The Vue instance representing the application.
 */
export const sentry = (app) => {
  // Sentry - Only run in production
  if (window?.location?.host === 'www.garmin.com') {
    Sentry.init({
      app,
      dsn: 'https://791779df14141318c19274e088119f80@o430870.ingest.sentry.io/4505845548187648',
      release: `${appName}@${appVersion}`,
      environment: 'production',
      logErrors: true,
    });
  }
};

export default sentry;
